import { gql } from '../../../apollo/__generated__';

export const USER_MATCHES = gql(`
  query UserMatches($eventId: ID!) {
    userMatches(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      hasSuperLikedMe(eventId: $eventId)
      isSuperLiked(eventId: $eventId)
    }
  }
`);
